import { createUseStyles } from 'react-jss'

import { colors } from 'components/common'

const useRangeStyles = createUseStyles({
  rangeWrapper: {
    display: 'flex',
    flexDirection: 'column',

    '& > label': {
      fontWeight: 'bold',
      color: colors.gray600,
      fontSize: 12,
      margin: '0.5rem 0'
    }
  },
  rangeInputWrapper: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 150,

    '& > .range-value': {
      fontSize: 12,
      fontWeight: 'bold',
      marginLeft: '1rem'
    }
  },
  rangeInput: {
    '-webkit-appearance': 'none',
    outline: 0,
    backgroundColor: colors.gray200,
    height: 3,

    '&.isReversed': {
      direction: 'rtl'
    },

    '&::-webkit-slider-thumb': {
      '-webkit-appearance': 'none',
      appearance: 'none',
      backgroundColor: colors.theme500,
      width: 15,
      height: 15,
      borderRadius: '100%',
      cursor: 'pointer'
    },

    '&::-moz-range-thumb': {
      appearance: 'none',
      width: 20,
      height: 20,
      cursor: 'pointer'
    }
  },

  rangeInputNumber: {
    marginLeft: '1rem',
    padding: 3,
    border: `1px solid ${colors.gray300}`,
    borderRadius: 4,
    width: 60
  }
})

export { useRangeStyles }
